export interface OnboardingQuestion {
  id: string
  message: string
  field: string
  type: 'select' | 'input' | 'multi-select'
  options?: { label: string; value: string }[]
}

export const onboardingQuestions: OnboardingQuestion[] = [
  {
    id: 'company_name',
    message: "👋 Welcome! I'm your AI assistant. Let's start with your company name - what is the name of your business?",
    field: 'companyName',
    type: 'input'
  },
  {
    id: 'business_type',
    message: "Great! Now, what's your business type?",
    field: 'businessType',
    type: 'select',
    options: [
      { label: 'Sdn Bhd', value: 'sdn_bhd' },
      { label: 'Enterprise', value: 'enterprise' },
      { label: 'Sole Proprietor', value: 'sole_proprietor' },
      { label: 'Partnership', value: 'partnership' }
    ]
  },
  {
    id: 'industry',
    message: "What industry are you in? This helps me suggest the right Chart of Accounts and expense categories.",
    field: 'industry',
    type: 'select',
    options: [
      { label: 'Technology & Software', value: 'technology' },
      { label: 'Retail & E-commerce', value: 'retail' },
      { label: 'Manufacturing', value: 'manufacturing' },
      { label: 'Professional Services', value: 'professional_services' },
      { label: 'Healthcare', value: 'healthcare' },
      { label: 'Construction', value: 'construction' },
      { label: 'Food & Beverage', value: 'food_beverage' },
      { label: 'Education', value: 'education' },
      { label: 'Real Estate', value: 'real_estate' },
      { label: 'Other', value: 'other' }
    ]
  },
  {
    id: 'financial_year_end',
    message: "What is your financial year end? This is needed for reporting and period closing.",
    field: 'financialYearEnd',
    type: 'select',
    options: [
      { label: 'December 31', value: '12-31' },
      { label: 'March 31', value: '03-31' },
      { label: 'June 30', value: '06-30' },
      { label: 'September 30', value: '09-30' }
    ]
  },
  {
    id: 'revenue_threshold',
    message: "Is your annual revenue above RM500,000? This determines SST registration requirements.",
    field: 'revenueAboveThreshold',
    type: 'select',
    options: [
      { label: 'Yes, above RM500,000', value: 'yes' },
      { label: 'No, below RM500,000', value: 'no' },
      { label: 'Not sure', value: 'not_sure' }
    ]
  },
  {
    id: 'sst_registration',
    message: "Are you SST-registered? If yes, please provide your SST number and effective date.",
    field: 'sstRegistration',
    type: 'input'
  },
  {
    id: 'foreign_currency',
    message: "Do you use foreign currency transactions? This enables forex account setup if needed.",
    field: 'usesForeignCurrency',
    type: 'select',
    options: [
      { label: 'Yes, regularly', value: 'yes_regularly' },
      { label: 'Yes, occasionally', value: 'yes_occasionally' },
      { label: 'No', value: 'no' }
    ]
  },
  {
    id: 'existing_data',
    message: "Do you have existing accounting data to import (trial balance / opening balance)?",
    field: 'hasExistingData',
    type: 'select',
    options: [
      { label: 'Yes, I have trial balance', value: 'yes_trial_balance' },
      { label: 'Yes, I have opening balance', value: 'yes_opening_balance' },
      { label: 'No, this is a new company', value: 'no_new_company' },
      { label: 'No, starting fresh', value: 'no_fresh_start' }
    ]
  },
  {
    id: 'document_types',
    message: "What types of documents will you upload regularly?",
    field: 'documentTypes',
    type: 'multi-select',
    options: [
      { label: 'Sales invoices', value: 'sales_invoices' },
      { label: 'Supplier bills', value: 'supplier_bills' },
      { label: 'Receipts', value: 'receipts' },
      { label: 'Bank statements', value: 'bank_statements' },
      { label: 'Payroll documents', value: 'payroll' },
      { label: 'Expense claims', value: 'expense_claims' },
      { label: 'Purchase orders', value: 'purchase_orders' }
    ]
  },
  {
    id: 'bank_accounts',
    message: "How many bank accounts do you have? This is needed for bank reconciliation setup.",
    field: 'bankAccountCount',
    type: 'select',
    options: [
      { label: '1 account', value: '1' },
      { label: '2-3 accounts', value: '2-3' },
      { label: '4-5 accounts', value: '4-5' },
      { label: 'More than 5 accounts', value: '5+' }
    ]
  },
  {
    id: 'loans_assets',
    message: "Do you have any loans or hire purchase agreements? Also, do you have fixed assets that need depreciation calculation?",
    field: 'loansAndAssets',
    type: 'input'
  }
]